export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.8.27-1309.52",
  commitId: "70ae82069ae8e6b4b1f2158d0f842f780d0829c6",
  commitTime: "2026-08-27T13:09:52.000Z",
});
